import classNames from 'classnames';
import type { FC, ReactElement, ReactNode } from 'react';
import { memo } from 'react';

import { Check as ValidIcon, Clear as ClearIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

interface ValidIndicatorLabelProps {
    value: boolean | string;
    validator: (value: boolean | string) => boolean;
    label: string;
    className?: string;
    validIcon?: ReactNode;
    invalidIcon?: ReactNode;
    loading?: boolean;
}

export const ValidIndicatorLabel: FC<ValidIndicatorLabelProps> = memo(
    ({
        value,
        validator,
        label,
        className,
        validIcon,
        invalidIcon,
        loading = false,
    }: ValidIndicatorLabelProps): ReactElement => {
        const hasError = !value ? true : validator(value);
        const icon = loading ? (
            <CircularProgress className="loading_validation" />
        ) : hasError ? (
            invalidIcon ? (
                invalidIcon
            ) : (
                <ClearIcon className="InvalidIcon" />
            )
        ) : validIcon ? (
            validIcon
        ) : (
            <ValidIcon className="ValidIcon" />
        );
        const combinedClassName = classNames(className, 'CIValidIndicatorLabel');

        return (
            <span className={combinedClassName}>
                {icon} {label}
            </span>
        );
    }
);
